import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSGridModule, NSSkeletonModule } from '@norfolk-southern/accessns-components';

import { DialogFooterModule } from '@ruby/shared/dialogs/dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from '@ruby/shared/dialogs/dialog-header/dialog-header.module';
import { PermitVesselActionComponent } from '@ruby/shared/dialogs/unit-train/vessel-event/components/permit-vessel-action/permit-vessel-action.component';
import { VesselEventDialog } from '@ruby/shared/dialogs/unit-train/vessel-event/components/vessel-event/vessel-event.dialog';
import { VesselEventContainer } from '@ruby/shared/dialogs/unit-train/vessel-event/containers/vessel-event.container';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';

@NgModule({
  declarations: [VesselEventContainer, VesselEventDialog, PermitVesselActionComponent],
  imports: [
    CommonModule,
    DialogHeaderModule,
    DialogFooterModule,
    MatButtonModule,
    MatDialogModule,
    NSSkeletonModule,
    NSGridModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    DirectivesModule,
    ReactiveFormsModule,
    MatSelectModule,
    PipesModule
  ],
  exports: [VesselEventContainer]
})
export class VesselEventDialogModule {}
